import { List, New, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/lrc-approval-list",
        component: List,
        name: "setting.lrc-approval-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/lrc-approval-new",
        component: New,
        name: "setting.lrc-approval-new",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/setting/lrc-approval/:id/edit",
        component: Edit,
        name: "setting.lrc-approval-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
